import debounce from 'lodash/debounce'
import { useCallback, useMemo, useRef } from 'react'
import { UpdateConjointItemArgsInput } from '../../data/gql-gen/questionnaire/graphql'
import { LoggerErrorType } from '../../data/logger'
import { captureApolloError } from '../../utils/HelperFunctions'
import { useUpdateQuestionnaireEntry } from './useUpdateQuestionnaireEntry'

export const useUpdateConjoint = ({ questionId }: { questionId: string }) => {
  const { updateQuestionnaireEntry, loading } = useUpdateQuestionnaireEntry(
    questionId,
    {
      onError: (error) => {
        captureApolloError(
          LoggerErrorType.ApolloMutation,
          'updateConjoint',
          error
        )
      }
    }
  )

  const updateConjoint = useCallback(
    (input: UpdateConjointItemArgsInput) => {
      return updateQuestionnaireEntry({
        updateConjoint: {
          ...input
        }
      })
    },
    [updateQuestionnaireEntry]
  )

  const debouncedRef = useRef<ReturnType<typeof debounce>>()

  const updateConjointDebounced = useMemo(() => {
    const debouncedFn = debounce((input: UpdateConjointItemArgsInput) => {
      updateQuestionnaireEntry({
        updateConjoint: {
          ...input
        }
      })
    }, 1000)

    debouncedRef.current = debouncedFn
    return debouncedFn
  }, [updateQuestionnaireEntry])

  const cancelPendingUpdate = useCallback(() => {
    debouncedRef.current?.cancel()
  }, [])

  return {
    updateConjoint,
    updateConjointDebounced,
    cancelPendingUpdate,
    loading
  }
}
